<template>
    <div class="vacation_info" v-if="obj_to_null(vacation)">
        <BBadge variant="warning">Відпустка на період {{vacation.d_from}} - {{vacation.d_to}}</BBadge>
    </div>
</template>

<script>

import {
    BBadge
} from 'bootstrap-vue-next';
export default {
    name: "vacation",
    props: {
        id: {
            type: Number,
            default: 0,
        },
    },
    
    components : {
        BBadge
    },
    
    data() {
        return {
            u_id      : this.id,
            vacation  : null,
        }
    },
    
    computed: {
        
        user_vacation() {
            if(this.obj_to_null(this.u_user) != null) {
                if(this.obj_to_null(this.u_user.vacation_info)) {
                    return this.u_user.vacation_info;
                }
            }
            return null;
        },
        
    },
    
    mounted() {
        if(this.u_id > 0) {
            this.getUser();
        }
    },
    
    methods: {
        async getUser () {
            await api.get('/user/' + this.u_id + '/internal/vacation').then(({data}) => {
                if(data.status === "operation_success") {
                    this.vacation = data.data;
                }
                else {
                    this.vacation = null;
                }
                
            }).catch(err => {
                this.vacation = {};
                console.log(err);
            });
        },
    },
}
</script>

<style scoped>

</style>
